import React, { useMemo } from 'react';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';
import type { ProposalBundle } from '../../types/proposalBundles';
import LegBlock from './LegBlock';

interface Props {
  outward: ProposalBundle;
  homeward: ProposalBundle;
  includeTax: boolean;
}

const PairRoundTripCard = ({ outward, homeward, includeTax }: Props) => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  return (
    <div style={styles.pairBundleCard}>
      <div style={styles.pairOuterHeader}>
        <span style={styles.pairBundleTitle}>航空券（往復）</span>
      </div>
      <LegBlock bundle={outward} legLabel="行き" includeTax={includeTax} />
      <div style={styles.pairLegDivider} />
      <LegBlock bundle={homeward} legLabel="帰り" includeTax={includeTax} />
    </div>
  );
};

const getStyles = (theme: AITTheme) => ({
  pairBundleCard: {
    padding: '10px 12px',
    backgroundColor: theme.contentBgColor,
    borderRadius: '6px',
    border: `1px solid ${theme.grayBorderColor}`
  },
  pairOuterHeader: {
    marginBottom: '8px'
  },
  pairBundleTitle: {
    fontSize: '13px',
    fontWeight: 600 as const,
    color: theme.textColor
  },
  pairLegDivider: {
    borderTop: `1px solid ${theme.grayBorderColor}`,
    margin: '10px 0'
  }
});

export default PairRoundTripCard;
